// extracted by mini-css-extract-plugin
module.exports = {"chip":"_1YoXDeUmS5BV-GPLfGXNMs","chip-inactive":"_3BMlYKsDBN2K1XmkWbyc3p _1YoXDeUmS5BV-GPLfGXNMs"};